import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import type { ApiError } from '../types';

const END_POINT = '/configuration';

export type UniversalMfaConfiguration = {
    authFilters: {
        userType: number[];
        excludeDirectoryTypes: string[];
        excludeUserGuids: string[];
    };
};

const fetchConfiguration = async (): Promise<UniversalMfaConfiguration> => {
    return await apiGet<UniversalMfaConfiguration>(`${API_BASE_URL}${END_POINT}`);
};

export const useConfiguration = (): UseQueryResult<UniversalMfaConfiguration, ApiError> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.configuration(),
        queryFn: () => fetchConfiguration()
    });
};
